import React, { useMemo, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useI18n } from '@oneaudi/i18n-context';
import { EquipmentComponent, EquipmentFilterOverlayNavigationHeaderMobile, EquipmentOverlayWrapper, LayerHeading, } from '../styles/EquipmentFilter.styles';
import { useServicesContext } from '../../../context';
import { getFiltersInCategoryArray } from '../utils/utils';
import { FilterOverlayFooter } from './FilterOverlayFooter';
import { FilterOverlayAccordion } from './FilterOverlayAccordion';
import { FilterOverlayAccordionSection } from './FilterOverlayAccordionSection';
import { ANCHOR_MOBILE, EQSECTION } from './Filter';
import { trackClicks } from '../tracking';
import { useScsUrlParts } from '../../../hooks';
import styled from 'styled-components';
import { Headline, TextButton, IconButton, } from '@oneaudi/unified-web-components';
import { ThemeProvider } from '@oneaudi/unified-web-common';
import { DynamicComponent, DynamicThemeProviderWrapper } from '../../utils';
import { SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-alpha-common';
export const EquipmentAccordion = ({ configFilterCategory, categories, className, mobileOrDesktop, overlayRef, equipmentFilterHeadingForTracking, renderFilters, }) => {
    var _a;
    const scsUrlParts = useScsUrlParts();
    const isUsedCarMkt = (_a = scsUrlParts === null || scsUrlParts === void 0 ? void 0 : scsUrlParts.marketPath) === null || _a === void 0 ? void 0 : _a.includes('uc');
    const market = isUsedCarMkt ? 'uc' : 'nc';
    const subCategoryHeading1 = useI18n({
        id: `nemo.sc.filter.equipmentfilter.subCategoryHeading1.${market}`,
        defaultMessage: 'Lines & Packages',
    });
    const subCategoryHeading2 = useI18n({
        id: `nemo.sc.filter.equipmentfilter.subCategoryHeading2.${market}`,
        defaultMessage: 'Exterieur',
    });
    const subCategoryHeading3 = useI18n({
        id: `nemo.sc.filter.equipmentfilter.subCategoryHeading3.${market}`,
        defaultMessage: 'Inteurieur',
    });
    const subCategoryHeading4 = useI18n({
        id: `nemo.sc.filter.equipmentfilter.subCategoryHeading4.${market}`,
        defaultMessage: 'Technology & Security',
    });
    const subCategoryHeading5 = useI18n({
        id: `nemo.sc.filter.equipmentfilter.subCategoryHeading5.${market}`,
        defaultMessage: '',
    });
    const subCategoryHeading6 = useI18n({
        id: `nemo.sc.filter.equipmentfilter.subCategoryHeading6.${market}`,
        defaultMessage: '',
    });
    const subCategoryHeading7 = useI18n({
        id: `nemo.sc.filter.equipmentfilter.subCategoryHeading7.${market}`,
        defaultMessage: '',
    });
    const subCategoryHeading8 = useI18n({
        id: `nemo.sc.filter.equipmentfilter.subCategoryHeading8.${market}`,
        defaultMessage: '',
    });
    const subCategoryHeadings = [
        subCategoryHeading1,
        subCategoryHeading2,
        subCategoryHeading3,
        subCategoryHeading4,
        subCategoryHeading5,
        subCategoryHeading6,
        subCategoryHeading7,
        subCategoryHeading8,
    ];
    const accordionSectionHeadingLevel = 'h5';
    const filterGroupHeadingLevel = 'h6';
    return (React.createElement(FilterOverlayAccordion, { className: `equipment-accordion ${className}`, isUsedInEquipmentFilter: true, overlayRef: overlayRef, mobileOrDesktop: mobileOrDesktop }, categories === null || categories === void 0 ? void 0 : categories.map((category, index) => {
        return (React.createElement(FilterOverlayAccordionSection, { key: index, id: `${EQSECTION}${index + 1}${ANCHOR_MOBILE}`, label: subCategoryHeadings[index], accordionSectionHeadingLevel: accordionSectionHeadingLevel, equipmentFilterHeadingForTracking: equipmentFilterHeadingForTracking, configFilterCategory: configFilterCategory, isLast: index === categories.length - 1 }, renderFilters(category, mobileOrDesktop, filterGroupHeadingLevel)));
    })));
};
export const EquipmentFilter = ({ configFilterCategory, equipmentFilterCategories, equipmentFilterCategoryLabel, renderFilters, closeOverlay, clearAllFilters, }) => {
    const showAllEquipmentFiltersButtonAndHeading = useI18n({
        id: `nemo.sc.filter.equipmentfilter.showAllEquipmentFiltersButtonAndHeading`,
        defaultMessage: 'See all equipment',
    });
    const equipmentFilterOverlayDescription = useI18n({
        id: `nemo.sc.filter.equipmentfilter.overlayDescription`,
        defaultMessage: 'All equipment by category',
    });
    const EquipmentFilterCloseButtonAriaLabel = useI18n({
        id: `nemo.sc.filter.equipmentfilter.closeButtonAriaLabel`,
        defaultMessage: 'Close the equipment filter overlay and return to the general filter overview',
    });
    const layerManager = useServicesContext().getAdditionalService('layer-manager');
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const [equipmentLayerNode, setEquipmentLayerNode] = useState();
    const [equipmentLayer, setEquipmentLayer] = useState();
    const equipmentLayerRef = React.useCallback((node) => {
        setEquipmentLayerNode(node);
    }, [setEquipmentLayerNode]);
    const equipmentOverlayRef = useRef(null);
    const openOverlay = () => {
        const layer = layerManager.openFullscreenLayer(() => React.createElement("div", { ref: equipmentLayerRef }), {}, {
            onClose: () => handleCloseEquipmentOverlay(),
        });
        setEquipmentLayer(layer);
    };
    const handleCloseEquipmentOverlay = () => {
        equipmentLayer === null || equipmentLayer === void 0 ? void 0 : equipmentLayer.close();
    };
    const handleCloseBothOverlays = () => {
        handleCloseEquipmentOverlay();
        closeOverlay();
    };
    const handleClick = () => {
        const trackingEventName = 'vtp filter - click on category - layer open';
        trackClicks(trackingService, trackingEventName, showAllEquipmentFiltersButtonAndHeading, 'button', equipmentFilterCategoryLabel, false);
        openOverlay();
    };
    const someCategoriesAreEmpty = useMemo(() => {
        return equipmentFilterCategories.some((eqcategory) => eqcategory.filterGroups.length === 0);
    }, [equipmentFilterCategories]);
    const equipmentCategories = equipmentFilterCategories === null || equipmentFilterCategories === void 0 ? void 0 : equipmentFilterCategories.map((category) => {
        return Object.assign(Object.assign({}, category), { selectedFilters: 0, filterGroups: getFiltersInCategoryArray(category) });
    });
    const popularItemsCategory = equipmentCategories.shift();
    if (someCategoriesAreEmpty) {
        console.warn('There are filterGroups missing in at least one of the %cEquipment-Filter', 'color: yellow; font-style: bold; background-color: blue; padding: 2px', ' Sub-Categories. Please configure the filterGroups in the equipmentFilter configuration section.');
        return null;
    }
    return (React.createElement(EquipmentComponent, { className: "equipment-component", "data-testid": "equipment-filter-component" },
        renderFilters(popularItemsCategory, 'desktop'),
        React.createElement(StyledHeadline, { className: "show-equipment-sub-heading-desktop", tag: "h4", variant: {
                order: '3',
                type: 'headline',
                weight: 'normal',
            } }, showAllEquipmentFiltersButtonAndHeading),
        React.createElement(DynamicComponent, { legacy: React.createElement(StyledTextButton, { variant: "tertiary", icon: "forward", iconPosition: "trailing", onClick: handleClick, "data-testid": "close-equipment-filter-button", className: "show-equipment-filter-overlay-button-mobile", key: "showallequipmentbutton" }, showAllEquipmentFiltersButtonAndHeading) }),
        React.createElement(DynamicComponent, { alpha: React.createElement(StyledTextButtonAlpha, { variant: "secondary", onClick: handleClick, "data-testid": "close-equipment-filter-button", className: "show-equipment-filter-overlay-button-mobile", key: "showallequipmentbutton", isFullWidth: true }, showAllEquipmentFiltersButtonAndHeading) }),
        React.createElement(React.Fragment, null, equipmentLayerNode &&
            ReactDOM.createPortal(React.createElement(EquipmentOverlayWrapper, { ref: equipmentOverlayRef },
                React.createElement(ThemeProvider, { theme: { name: 'dark' } },
                    React.createElement(EquipmentFilterOverlayNavigationHeaderMobile, { className: "equipment-filter-layer-header" },
                        React.createElement(IconButton, { variant: "tertiary", icon: "back", size: "sm", onClick: handleCloseEquipmentOverlay, "aria-label": EquipmentFilterCloseButtonAriaLabel, "data-tracking-exclude": true }),
                        React.createElement(StyledHeadline, { tag: "h2", variant: {
                                order: '4',
                                type: 'headline',
                                weight: 'bold',
                            } }, showAllEquipmentFiltersButtonAndHeading))),
                React.createElement(DynamicThemeProviderWrapper, null,
                    React.createElement(LayerHeading, null,
                        React.createElement(StyledHeadlineH3, { tag: "h4", variant: {
                                order: '4',
                                type: 'headline',
                                weight: 'normal',
                            } }, equipmentFilterOverlayDescription)),
                    React.createElement(EquipmentAccordion, { configFilterCategory: configFilterCategory, categories: equipmentCategories, renderFilters: renderFilters, mobileOrDesktop: "mobile", className: "equipment-filter--mobile", overlayRef: equipmentOverlayRef, equipmentFilterHeadingForTracking: showAllEquipmentFiltersButtonAndHeading }),
                    React.createElement(FilterOverlayFooter, { closeOverlay: handleCloseBothOverlays, clearAllFilters: clearAllFilters }))), equipmentLayerNode)),
        React.createElement(EquipmentAccordion, { configFilterCategory: configFilterCategory, categories: equipmentCategories, renderFilters: renderFilters, mobileOrDesktop: "desktop", className: "equipment-filter--desktop", equipmentFilterHeadingForTracking: showAllEquipmentFiltersButtonAndHeading })));
};
const StyledHeadline = styled((props) => React.createElement(Headline, Object.assign({}, props))) `
  margin: var(--spacing-relative-lg) 0 var(--spacing-relative-lg) 0;
`;
const StyledTextButton = styled((props) => React.createElement(TextButton, Object.assign({}, props))) `
  margin: var(--spacing-relative-xl) 0 var(--spacing-relative-xl) 0;
  padding: 0;
  min-height: 0;
`;
const StyledTextButtonAlpha = styled((props) => React.createElement(TextButton, Object.assign({}, props))) `
  margin-top: ${SYS_SPACE_FIXED_300};
  margin-bottom: ${SYS_SPACE_FIXED_200};
`;
const StyledHeadlineH3 = styled((props) => React.createElement(Headline, Object.assign({}, props))) `
  margin-top: var(--spacing-relative-xl);
  margin-bottom: var(--spacing-relative-lg);
  margin-right: var(--spacing-relative-lg);
  margin-left: var(--spacing-relative-lg);
`;
